import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { ICloneTextTemplate } from './texttemplates-model';

@Injectable()
export class TextTemplatesService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'texttemplates';

    /** PUT */
    public cloneTextTemplate(data: ICloneTextTemplate): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .put<SuccessResponse<boolean>>(
                TextTemplatesService.URL +
                TextTemplatesService.ENDPOINT +
                '/' + 'clones',
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
